import '../DataCollection.css';
import {useForm} from "react-hook-form";
import {useState} from "react";

/*
* PasswordInput
* The best way to use this is to pass in the state object that has an attribute of the value you want to manage, the name of the variable in that state that you want to manage,
* and a function to update that state.  The onChange function will be called with the event object, and the state will be updated with the new value.

 */
const PasswordInput = ({ label, placeholder, value, name, state, validationRules, onChange, ...rest}) => {
    const { register, handleSubmit, watch, formState: { errors } } = useForm({mode: 'onBlur'});
    const [passwordVisible, setPasswordVisible] = useState(false);

    if (state) {
        value = state[name];
    }
    let errorClass = errors[name] ? 'error' : '';

    return (
        <div className={'form-input-area__input '}>
            <label>
                {label && <span>{label} </span>}
                <input {...register(name, validationRules)}
                       type={passwordVisible ? "text" : "password"}
                       name={name}
                       placeholder={placeholder}
                       value={value}
                       onChange={onChange}
                       className={errorClass}
                       {...rest}
                />
                {!passwordVisible &&
                    <span className="password-visibility-icon material-symbols-outlined" onClick={() => {setPasswordVisible(true)}}>
                        visibility
                    </span>
                }
                {passwordVisible &&
                    <span className="password-visibility-icon off material-symbols-outlined" onClick={() => {setPasswordVisible(false)}}>
                        visibility_off
                    </span>
                }
                {validationRules && validationRules.required && <span className={'required-input'}>*</span>}
            </label>
        </div>
    )
}

export default PasswordInput;